export function getBrowserTimezone(): TimeZone {
	return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
